import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const financeRoutes: RouteObject[] = [
  // Dashboard
  { path: 'Cash/HomePage', lazy: lazyRoute(() => import('../../pages/CASH/Main/CashDashboard')) },

  {
    path: 'CASH/Settings/*',
    children: [
      { path: 'BankAccounts', lazy: lazyRoute(() => import('../../pages/CASH/BankAccounts/Index')) },
      { path: 'CashBoxes', lazy: lazyRoute(() => import('../../pages/CASH/CashBoxes/Index')) }
    ]
  },

  {
    path: 'CASH/*',
    children: [
      { path: 'CashTransfer', lazy: lazyRoute(() => import('../../pages/CASH/CashTransfer/Index')) },
      { path: 'BankSettlement', lazy: lazyRoute(() => import('../../pages/CASH/BankSettlement/Index')) },
      { path: 'BankSettlement/AddBankSettlement/:id?', lazy: lazyRoute(() => import('../../pages/CASH/BankSettlement/BankSettlementForm')) }
    ]
  },

  // Reports
  { path: 'CASH/Reports', lazy: lazyRoute(() => import('../../pages/CASH/Reports/CashReports')) },
  {
    path: 'CASH/Reports/:ReportId/ReportsBuilder',
    lazy: lazyRoute(() => import('../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder'))
  }
];

export default financeRoutes;
